import * as types from '../constants'

const initialState = {
  campaign: {},
}

const products = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_CAMPAIGN:
      return { ...state, campaign: action.payload }
    default:
      return state
  }
}

export default products



// WEBPACK FOOTER //
// ./src/store/campaigns/reducer.js